<template>
  <v-container class="pt-0">
    <v-row>
      <v-col cols="12">
        <indices-data-table :indices="indices" :loading="loading" @rechargeTable="getIndices()"></indices-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import IndicesCOGE from '@/services/IndicesCOGEService';

  export default {
    name: 'IndicesCOGEVisualizar',

    components: {
      IndicesDataTable: () => import('@/components/indicesCOGE/IndicesDataTable.vue')
    },

    data() {
      return {
        indices: [],
        loading: false
      };
    },
    mounted() {
      if (this.$route.params.data_registro) {
        this.getIndices(this.$route.params.data_registro);
      }
    },
    methods: {
      getIndices(data_registro) {
        this.loading = true;

        IndicesCOGE.exibir(data_registro)
          .then((response) => {
            this.indices = response.data.dados;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar Índices COGE', '', {
              position: 'topRight'
            });
            this.$router.push({ name: 'Indices COGE Histórico' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
